/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SWOTSessionReport', 'model/SWOTSession'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SWOTSessionReport'), require('../model/SWOTSession'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SWOTSessionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SWOTSessionReport, root.ForStractionServiceApi.SWOTSession);
  }
}(this, function(ApiClient, SWOTSessionReport, SWOTSession) {
  'use strict';

  /**
   * SWOTSession service.
   * @module api/SWOTSessionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SWOTSessionApi. 
   * @alias module:api/SWOTSessionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sWOTSessionAddPut operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/SWOTSessionReport} body 
     * @param {module:api/SWOTSessionApi~sWOTSessionAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.sWOTSessionAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sWOTSessionAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/SWOTSession/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTSessionCloseVoteBatchGet operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionCloseVoteBatchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * closeVoteBatch
     * @param {String} _4SAPIAppID 
     * @param {Integer} sessionID 
     * @param {module:api/SWOTSessionApi~sWOTSessionCloseVoteBatchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sWOTSessionCloseVoteBatchGet = function(_4SAPIAppID, sessionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionCloseVoteBatchGet";
      }

      // verify the required parameter 'sessionID' is set
      if (sessionID == undefined || sessionID == null) {
        throw "Missing the required parameter 'sessionID' when calling sWOTSessionCloseVoteBatchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sessionID': sessionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SWOTSession/closeVoteBatch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTSessionDeleteGet operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/SWOTSessionApi~sWOTSessionDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sWOTSessionDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling sWOTSessionDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SWOTSession/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTSessionEditPut operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/SWOTSession} body 
     * @param {module:api/SWOTSessionApi~sWOTSessionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sWOTSessionEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sWOTSessionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SWOTSession/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTSessionLoadAllGet operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SWOTSessionReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxVoteBatchesCount  (default to 0)
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/SWOTSessionApi~sWOTSessionLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SWOTSessionReport>}
     */
    this.sWOTSessionLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxVoteBatchesCount': opts['maxVoteBatchesCount'],
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [SWOTSessionReport];

      return this.apiClient.callApi(
        '/SWOTSession/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTSessionLoadGet operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SWOTSessionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxVoteBatchesCount  (default to 0)
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/SWOTSessionApi~sWOTSessionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SWOTSessionReport}
     */
    this.sWOTSessionLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling sWOTSessionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'maxVoteBatchesCount': opts['maxVoteBatchesCount'],
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SWOTSessionReport;

      return this.apiClient.callApi(
        '/SWOTSession/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTSessionStartVoteBatchGet operation.
     * @callback module:api/SWOTSessionApi~sWOTSessionStartVoteBatchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * startVoteBatch
     * @param {String} _4SAPIAppID 
     * @param {Integer} sessionID 
     * @param {module:api/SWOTSessionApi~sWOTSessionStartVoteBatchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sWOTSessionStartVoteBatchGet = function(_4SAPIAppID, sessionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTSessionStartVoteBatchGet";
      }

      // verify the required parameter 'sessionID' is set
      if (sessionID == undefined || sessionID == null) {
        throw "Missing the required parameter 'sessionID' when calling sWOTSessionStartVoteBatchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sessionID': sessionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SWOTSession/startVoteBatch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
